import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { Col, Row } from "react-bootstrap";
import "./bottoni.css";
import logo from "../media/photo1676672801.jpeg";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import Fotografie from "./carosello";
import facebook from "../media/kisspng-facebook-logo-social-media-computer-icons-icon-facebook-drawing-5ab02fb70b9ad5.png"
import instagram from "../media/kisspng-google-logo-brand-instagram-5ab6f4d915a620.2415440715219396730887.png"
import wattsapp from "../media/transparent-social-media-icons-icon-whatsapp-icon-5dd10656a77cf0.png"
import gomma from"../media/5a3674e16eab44.5762498915135183054533.png"

export default function TemporaryDrawer() {
  const [state, setState] = React.useState({
    left: false,
  });

  const [lgShow1, setLgShow1] = useState(false);
  const [lgShow2, setLgShow2] = useState(false);
  const [lgShow3, setLgShow3] = useState(false);
  const [lgShow4, setLgShow4] = useState(false);
  const [lgShow5, setLgShow5] = useState(false);
  const [lgShow6, setLgShow6] = useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      style={{ backgroundColor: "blue", height: "100%", color: "white" }}
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div>
          <Row>
            
          
            <Col
              style={{
                paddingRight: "0px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src={logo} alt="ciao" style={{ width: "65%" }} />
            </Col>
            <Col
              style={{
                padding: "0px",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <h1 id="tit" style={{ paddingRight: "30px"}}>Marco Gomme</h1>
            </Col>
          </Row>
          
        </div>
        <br />
        <Divider style={{ color: "white" }} />
        <br />
        <br />
        <Row>
          <Button
            onClick={() => setLgShow1(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Chi siamo
          </Button>
        </Row>
        <br />
        <Row>
          {" "}
          <Button
            onClick={() => setLgShow2(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Cosa facciamo
          </Button>
        </Row>
        <br />
        <Row>
          <Button
            onClick={() => setLgShow3(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Galleria
          </Button>
        </Row>
        <br />
        <Row>
          <Button
            onClick={() => setLgShow4(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Dove siamo
          </Button>
        </Row>
        <br />
        <Row>
          <Button
            onClick={() => setLgShow5(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Contatti
          </Button>
        </Row>
        <br />
        <Row>
          <Button
            onClick={() => setLgShow6(true)}
            style={{ textDecoration: "underline", color: "white" }}
          >
            Privacy
          </Button>
        </Row>
      </List>
    </Box>
  );

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={lgShow1}
        onHide={() => setLgShow1(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        >
          <Modal.Title id="example-modal-sizes-title-lg">
            <div><h2 >MARCO GOMME il tuo gommista!</h2></div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "black", color: "white" }}>
          <blockquote style={{ textAlign: "justify" }}>
            {" "}
            La nostra officina nasce dall’esperienza di Marco maturata da più di trent’anni nel settore delle gomme.
L’officina dispone di macchinari e attrezzature all’avanguardia di ultima generazione.
Trattiamo pneumatici sia nuovi che d’occasione, tutti selezionati e controllati.
          </blockquote>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={lgShow2}
        onHide={() => setLgShow2(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        >
          <Modal.Title id="example-modal-sizes-title-lg">
            <h2 >Affidati a Marco Gomme!</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "black", color: "white" }}>
          <blockquote style={{ textAlign: "justify"}}>
          L’azienda Marco gomme si occupa di montaggio gomme, convergenze, equilibrature, cerchi in lega, cambio d’olio, deposito stagionale, trattiamo pneumatici nuovi e d’occasione.
Inoltre effettuiamo soccorso stradale e soccorso a domicilio. 
            {" "}
          </blockquote>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        show={lgShow3}
        onHide={() => setLgShow3(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        >
          <Modal.Title id="example-modal-sizes-title-lg">
            <h2 >Scegli Marco Gomme!</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "black", color: "white" }}>
          <Fotografie />
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        show={lgShow4}
        onHide={() => setLgShow4(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        ></Modal.Header>

        <Modal.Body style={{ backgroundColor: "black", color: "white" }}>
          <p >ci trovi da lunedì a sabato in corso Bernardino Telesio 72/B, Torino</p>

          <div>
            <iframe
              width="100%"
              height="350"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=7.6266440749168405%2C45.079894143205046%2C7.628682553768158%2C45.08095853975432&amp;layer=mapnik&amp;marker=45.08042634395834%2C7.627663314342499"
              style={{ border: "1px solid black" }}
            ></iframe>
            <br />
            <small>
              <a href="https://www.openstreetmap.org/?mlat=45.08043&amp;mlon=7.62766#map=19/45.08043/7.62766">
                Visualizza mappa ingrandita
              </a>
            </small>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        show={lgShow5}
        onHide={() => setLgShow5(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        ></Modal.Header>
        <Modal.Body
          style={{
            backgroundColor: "black",
            
          }}
        >
          <Row style={{
            backgroundColor: "black",
            color: "white",
            display: "flex",
            justifyContent: "center",
          }}>
<Button
            variant="contained"
            style={{ backgroundColor: "blue", color: "white", marginTop: "25px" }}
          >
            <a
              href="tel:+393285953344"
              style={{ textDecoration: "none", color: "white" }}
            >
              <h5>
                Chiama ora <br />
                3285953344
              </h5>
            </a>
          </Button>

          </Row>

<Row>
  <h5 style={{
            backgroundColor: "black",
            color: "white",
            display: "flex",
            justifyContent: "center",
            paddingTop: "5px"
          }}>Oppure</h5>
</Row>

<Row style={{
            backgroundColor: "#210f0f",
            color: "white",
            display: "flex",
            justifyContent: "center",
          }}>
<Button
            variant="contained"
            href="mailto:marcogomme.demolizione@gmail.com"
            style={{ backgroundColor: "blue", color: "white" }}
          >
           
              <p  id='bottonemail' style={{paddingRight: '15%', paddingLeft: '15%'}}>
                Contattaci via mail <br/>
                marcogomme.demolizione@gmail.com
              </p> 
           
          </Button>

          </Row>





          <Row >
<h5 style={{
            backgroundColor: "black",
            color: "white",
            display: "flex",
            justifyContent: "left",
            paddingTop: "55px"
          }}>Seguici anche su:</h5>

          </Row>
          <Row >
            <div style={{
            
            display: "flex",
            justifyContent: "center",
            paddingTop: "3px",
            
          }}>
            <a href="https://www.facebook.com/profile.php?id=100064009834763
" target="_blank" rel="noreferrer" ><img src={facebook} alt="ciao" style={{ width: "75%" }} /></a>
            
            <a href="https://www.marcogommeusate.it" target="_blank" rel="noreferrer" ><img src={gomma} alt="ciao" style={{ width: "75%"}} /></a>
            <a href="https://wa.me/393285953344" target="_blank" rel="noreferrer" ><img src={wattsapp} alt="ciao" style={{ width: "75%"}} /></a>
            </div>
          
          </Row>

          
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={lgShow6}
        onHide={() => setLgShow6(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{ backgroundColor: "black", color: "white" }}
        >
          <Modal.Title id="example-modal-sizes-title-lg">
            <h2>Privacy Policy</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "black", color: "white" }}>
          <blockquote style={{ textAlign: "justify" }}>
            I –INFORMAZIONI RELATIVE ALLA PRIVACY POLICY DEL SITO In questa
            sezione sono contenute le informazioni relative alle modalità di
            gestione di marcogomme in riferimento alle trattamento dei dati
            degli utenti di marcogomme. La presente informativa ha valore anche
            ai fini dell’art. 13 del D.lgs. n. 196/2003, Codice in materia di
            protezione dei dati personali, e ai fini dell’art. 13 del
            Regolamento UE n. 2016/679, relativo alla protezione delle persone
            fisiche con riguardo al trattamento dei dati personali nonché alla
            libera circolazione di tali dati, per i soggetti che interagiscono
            con marcogomme ed è raggiungibile all’indirizzo corrispondente
            alla pagina iniziale: marcogomme L’informativa è reale solo per
            marcogomme e non anche per altri siti web eventualmente
            consultati dall’utente tramite link in esso contenuti. Scopo del
            presente documento è fornire indicazioni circa le modalità, i tempi
            e la natura delle informazioni che i titolari del trattamento devono
            fornire agli utenti al momento della connessione alle pagine web di
            marcogomme, indipendentemente degli scopi del collegamento
            stesso, secondo la legislazione Italiana ed Europea. L’informativa
            può subire modifiche a causa dell’introduzione di nuove norme al
            riguardo, si invita, pertanto, l’utente a controllare periodicamente
            la presente pagina. Se l’utente ha meno di sedici anni, ai sensi
            dell’art. 8, c. 1 regolamento UE 2016/679, dovrà legittimare il suo
            consenso attraverso l’autorizzazione dei genitori o di chi ne fa le
            veci. II- TRATTAMENTO DEI DATI Titolare dei dati Il titolare del
            trattamento è la persona fisica o giuridica, l’autorità pubblica, il
            servizio o altro organismo che, singolarmente o insieme ad altri,
            determina le finalità e i mezzi del trattamento di dati personali.
            Si occupa anche dei profili sulla sicurezza. Relativamente al
            presente sito web il titolare del trattamento è Marco Musicco e per
            ogni chiarimento o esercizio dei diritti dell’utente potrà
            contattarlo al seguente indirizzo mail: marcogomme.demolizione@gmail.com
            Responsabile del trattamento dei dati Il responsabile del
            trattamento è la persona fisica o giuridica, l’autorità pubblica, il
            servizio o altro organismo che tratta dati personali per conto del
            titolare del trattamento. Ai sensi dell’articolo 28 del Regolamento
            UE n. 2016/679, su nomina del titolare dei dati, il responsabile del
            trattamento dei dati del sito marcogomme è:
            Marco Musicco In caso di necessità, i dati connessi al servizio
            newsletter possono essere trattati dal responsabile del trattamento
            o soggetti dati esso incaricati a tal fine presso la relativa sede.
            III – COOKIES Tipo di cookies Il sito marcogomme utilizza
            cookies per rendere l’esperienza di navigazione dell’utente più
            facile ed intuitiva: i cookies sono piccole stringhe di testo
            utilizzate per memorizzare alcune informazioni che possono
            riguardare l’utente, le sue preferenze o il dispositivo di accesso
            ad internet (computer, tablet o cellulare) e vengono usate
            principalmente per adeguare il funzionamento del sito alle
            aspettative dell’utente, offrendo un’esperienza di navigazione più
            personalizzata e memorizzando le scelte effettuate in precedenza. Un
            cookies consiste in un ridotto insieme di dati trasferiti al browser
            dell’utente da un server web e può essere letto unicamente dal
            server che ha effettuato il trasferimento. Non si tratta di codice
            eseguibile e non trasmette virus. I cookies non registrano alcuna
            informazione personale e gli eventuali dati identificabili non
            verranno memorizzati. Se si desidera, è possibile impedire il
            salvataggio di alcuni o tutti i cookies. Tuttavia, in questo caso
            l’utilizzo del sito e dei servizi offerti potrebbe risultarne
            compromesso. Per procedere senza modificare le opzioni relative ai
            cookies è sufficiente continuare con la navigazione. Di seguito le
            tipologie di cookies di cui il sito fa uso: Cookies tecnici Ci sono
            numerose tecnologie usate per conservare informazioni nel computer
            dell’utente, che poi vengono raccolte da altri siti. Tra queste la
            più conosciuta ed utilizzata è HTML. Essi servono per la navigazione
            e per facilitare l’accesso e la fruizione del sito da parte
            dell’utente. Sono necessari alla trasmissione di comunicazioni su
            rete elettronica ovvero al fornitore per erogare il servizio
            richiesto dal cliente. Le impostazioni per gestire o disattivare i
            COOKIES possono variare a seconda del browser internet utilizzato.
            Ad ogni modo, l’utente può gestire o richiedere la disattivazione
            generale o la cancellazione dei cookies, modificando le impostazioni
            del proprio browser internet. Tale disattivazione può rallentare o
            impedire l’accesso ad alcune parti del sito. L’uso dei cookies
            tecnici consente la fruizione sicura ed efficiente del sito. I
            COOKIES che vengono inseriti nel browser e ritrasmessi mediante
            Google Analytics o tramite il servizio statistiche di blogger o
            similari sono tecnici solo se utilizzati ai fini di ottimizzazione
            del sito direttamente dal titolare del sito stesso, che potrà
            raccogliere informazioni in forma aggregata soul numero degli utenti
            e su come questi visitano il sito. A queste condizioni, per i
            COOKIES Analytics valgono le stesso regole, in tema di informativa e
            consenso, previste per i cookies tecnici. Dal punto di vista della
            durata si possono distinguere cookies temporanei di sessione che si
            cancellano automaticamente al termine della sessione di navigazione
            e servono per identificare l’utente e quindi evitare il login ad
            ogni pagina visitata e quelli permanenti che restano attivi nel pc
            fino a scadenza o cancellazione da parte dell’utente. Potranno
            essere installati cookies di sessione al fine di consentire
            l’accesso e la permanenza nell’area riservata del portale come
            utente autenticato. Essi non vengono memorizzati in modo persistente
            ma esclusivamente per la durata della navigazione fino alla chiusura
            del browser e svaniscono con la chiusura dello stesso. Il loro uso è
            strettamente limitato alla trasmissione di identificativi di
            sessione costituiti da numeri casuali generati dal server necessari
            per consentire l’esplorazione sicura ed efficiente del sito. Cookies
            di terze parti In relazione alla provenienza si distinguono i
            cookies inviati al browser direttamente dal sito che si sta
            visitando e quelli di terze parti inviati al computer dati altri
            siti e non da quello che si sta visitando. I cookies permanenti sono
            spesso cookies di terze parti. La maggior parte dei cookies di terse
            parti è costituita da cookies di tracciamento usati per individuare
            il comportamento online, capire gli interessi e quindi
            personalizzare le proposte pubblicitarie per gli utenti. Potranno
            essere installati cookies di terze parti analitici. Essi sono
            inviati da domini di predette terze parti esterni al sito. I cookies
            analitici di terze parti sono impiegati per rilevare informazioni
            soul comportamento degli utenti su marcogomme. La rilevazione
            avviene in forma anonima, al fine di monitorare le prestazioni e
            migliorare l’usabilità del sito. I cookies di profilazione di terze
            parti sono utilizzati per creare profili relativi agli utenti su
            marcogomme, al fine di proporre messaggi pubblicitari in linea
            con le scelte manifestate degli utenti medesimi. L’utilizzo di
            questi cookies è disciplinato dalle regole predisposte dalle terze
            parti medesime. Pertanto, si invitano gli utenti a prendere visione
            delle informative privacy e delle indicazioni per gestire o
            disabilitare i cookies pubblicate nelle relative pagine web. Cookies
            di profilazione Sono cookies di profilazione quello a creare profili
            all’utente e vengono utilizzati al fine di inviare messaggi
            pubblicitari in linea con le preferenze manifestate dallo stesso
            nell’ambito della navigazione in rete. Quando si utilizzeranno
            questi tipi di COOKIES l’utente dovrà dare un consenso esplicito. Si
            applicherà l’articolo 22 del Regolamento UE 2016/679 e l’articolo
            122 del Codice in materia di protezione dei dati. IV- DATI TRATTATI
            1. Modalità trattamento dati Come tutti i siti web anche il presente
            sito fa uso di log files nei quali vengono conservate informazioni
            raccolte in maniera automatizzata durante le visite degli utenti. Le
            informazioni raccolte potrebbero essere le seguenti: Indirizzo
            internet protocol (IP); – Tipo di browser e parametri del
            dispositivo usato per connettersi al sito; – Nome dell’internet
            service provider (ISP); – Data e orario di visita; – Pagina web di
            provenienza del visitatore (referal) e di uscita; – Eventualmente il
            numero di click. Le suddette informazioni sono test rate in forma
            automatizzata e raccolte in forma esclusivamente aggregata al fine
            di verificare il corretto funzionamento del sito e per motivi di
            sicurezza. Tali informazioni saranno test rate in base ai legittimi
            interessi del titolare. Ai fini di sicurezza (filtri anti-spam,
            firewall, rilevazione virus) i dati registrati automaticamente
            possono eventualmente comprendere anche dati personali come
            l’indirizzo IP, che potrebbe essere utilizzato, conformemente alle
            leggi vigenti in materia, a fine di bloccare tentativi di
            danneggiamento al sito medesimo o di recare danno ad altri utenti o
            attività dannose o costituenti reato. Tali dati non sono mai
            utilizzati per l’identificazione o la profilazione dell’utente, ma
            solo ai fini di tutela del sito e dei suoi utenti, tali informazioni
            saranno usate in base ai legittimi interessi del titolare. Qualora
            il sito consenta l’inserimento di commenti, oppure in caso di
            specifici servizi richiesti dall’utente, ivi compresi la possibilità
            di inviare il Curriculum Vitae per un eventuale rapporto lavorativo,
            il sito rileva automaticamente e registra alcuni dati identificativi
            dell’utente, compreso l’indirizzo mail. Tali dati si intendono
            volontariamente forniti dall’utente al momento della richiesta di
            erogazione del servizio. Inserendo un commento o altra informazione
            l’utente accetta espressamente l’informativa privacy e, in
            particolare, acconsente che i contenuti inseriti siano liberamente
            diffusi anche a terzi. I dati ricevuti verranno utilizzati
            esclusivamente per l’erogazione del servizio richiesto e per il solo
            tempo necessario per la fornitura del servizio. Le informazioni che
            gli utenti del sito riterranno di rendere pubbliche tramite i
            servizi e gli strumenti messi a disposizione degli stessi, sono
            fornite dall’utente consapevolmente e volontariamente, esentando il
            presente sito da qualsiasi responsabilità in merito ad eventuali
            violazioni delle leggi. Spetta all’utente verificare di avere i
            permessi per l’immissione di dati personali di terzi o di contenuti
            tutelati dalle norme nazionali ed internazionali. 2. Finalità del
            trattamento dati I dati raccolti dal sito durante il suo
            funzionamento sono utilizzati esclusivamente per le finalità sopra
            indicate e conservati per il tempo strettamente necessario a
            svolgere le attività precisate e, comunque, non oltre 2 anni. I dati
            utilizzati ai fini di sicurezza (blocco tentativi di danneggiamento
            del sito) sono conservati per il tempo strettamente necessario al
            raggiungimento del fine anteriormente indicato. 3. Dati forniti
            dall’utente Come sopra indicato, l’invio facoltativo, esplicito e
            volontario di posta elettronica agli indirizzi indicate su questo
            sito comporta la successive acquisizione dell’indirizzo del
            mittente, necessario per rispondere alle richieste, nonché degli
            eventuali altri dati personali inseriti nella missiva. Specifiche
            informative di sintesi verranno progressivamente riportate o
            visualizzate nelle pagine del sito predisposte per particolari
            servizi a richiesta. 4. Supporto nella configurazione del proprio
            browser L’utente può gestire i cookies anche attraverso le
            impostazioni del suo browser. Tuttavia, cancellando i cookies dal
            browser potrebbe rimuovere le preferenze che ha impostato per il
            sito. Per ulteriori informazioni e supporto è possible anche
            visitare la pagina di aiuto specifica del web browser che si sta
            utilizzando: Internet explorer Firefox Safari Chrome Opera 5.Plugin
            Social Network Il presente sito incorpora anche plugin e/o bottoni
            per i social network, al fine di consentire una facile condivisione
            dei contenuti sui vostri social network preferiti. Tali plugin sono
            programmati in modo da non impostare alcun cookie all’accesso della
            pagina per salvaguardare la privacy degli utenti. Eventualmente i
            cookies vengono impostati, se così previsto dai social network solo
            quando l’utente fa effettivo e volontario uso del plugin. Si tenga
            presente che se l’utente naviga essendo loggato nel social network
            allora ha già acconsentito all’uso dei cookies veicolati tramite
            questo sito al momento dell’iscrizione al social network. La
            raccolta e l’uso delle informazioni ottenute a mezzo del plugin sono
            regolati dalle rispettive informative privacy dei social network,
            alle quali si prega di fare riferimento: Facebook:
            https://www.facebook.com/help/cookies Twitter:
            https://support.twitter.com/articles/20170519-uso-dei-cookie-e-d-altre-tecnologie-simili-da-parte-di-twitter
            Google +: http://www.google.com/polices/techonologies/cookies
            Pinterest: https://about.pinterest.com/it/privacy-policy AddThis:
            http://www.addthis.com/privacy/privacy-policy Linkedin:
            https://www.linkedin.com/legal/cookie/policy V- DIRITTI DELL’UTENTE
            L’art. 13 co. 2 del Regolamento UE del 2016/679 elenca i diritti
            dell’utente. Il presente sito marcogomme intende, pertanto,
            informare l’utente sull’esistenza: – del diritto dell’interessato di
            chiedere al titolare l’accesso ai dati personali (art. 15
            Regolamento UE), il loro aggiornamento (art. 7, co. 3, lett. a del
            D.lgs 196/2003), la rettifica (art. 16 Regolamento UE),
            l’integrazione (art. 7, co. 3 lett. a D.lgs 196/2003), la
            limitazione del trattamento che lo riguardino (art. 18 Regolamento
            UE) o di opporsi, per motivi legittimi, al loro trattamento (art. 21
            Regolamento UE), oltre al diritto alla portabilità dei dati (art. 20
            Regolamento UE); – del diritto di chiedere la cancellazione (art. 17
            Regolamento UE), la trasformazione in forma anonima o il blocco dei
            dati trattati in violazione di legge, compresi quelli di cui non è
            necessaria la conservazione in relazione agli scopi per i quali i
            dati sono stati raccolti o successivamente trattati (art. 7 co. 3,
            lett. b del D.lgs. 196/2003); – del diritto di ottenere
            l’attestazione che le operazioni di aggiornamento, rettificazione,
            integrazione dei dati, cancellazione, blocco dei dati,
            trasformazione, sono state portate a conoscenza, anche per quanto
            riguarda il loro contenuto, di coloro ai quali i dati sono stati
            comunicati o diffusi, eccettuato il caso in cui tale adempimento si
            rivela impossibile o comporta un impiego di mezzi manifestamente
            sproporzionato rispetto al diritto tutelato (art. 7 co. 3, lett. c
            del D.lgs 196/2003). Le richieste possono essere indirizzate al
            titolare del trattamento al suo indirizzo email summenzionato (senza
            formalità) oppure utilizzando il modello previsto dal Garante per la
            protezione dei dati personali. Qualora il trattamento sia basato
            sull’art. 6 paragrafo 1 lettera a – consenso espresso all’utilizzo –
            oppure sull’art. 9 paragrafo 2 lettera a – consenso espresso
            all’utilizzo di dati genetici, biometrici, relativi alla salute, che
            rivelino convinzioni religiose, filosofiche o appartenenza
            sindacale, che rivelino l’origine razziale o etnica, le opinioni
            politiche – l’utente ha il diritto di revocare il consenso in
            qualsiasi momento senza pregiudicare la liceità del trattamento
            basata sul consenso prestato prima della revoca. Parimenti, in caso
            di violazione della normativa, l’utente ha il diritto di proporre
            reclamo presso il Garante per la Protezione dei Dati Personali,
            quale autorità preposta al controllo sul trattamento nello Stato
            italiano. Per una disamina più approfondita dei diritti che Le
            competono, si vedano gli artt. 15 e ss. Del Regolamento UE 2016/679
            e l’art. 7 del D.lgs. 196/2003. VI – ADEMPIMENTI Il titolare
            notifica al Garante il trattamento di dati personali cui intende
            procedere, solo se il trattamento riguarda: – dati genetici,
            biometrici o dati che indicano la posizione geografica di persone od
            oggetti mediante una rete di comunicazione elettronica; – dati
            idonei a rivelare lo stato di salute e la vita sessuale, trattati ai
            fini di procreazione assistita, prestazione di servizi sanitari per
            via telematica relativi a banche di dati o alla fornitura di beni,
            indagini epidemiologiche, rilevazione di malattie mentali, infettive
            e diffusive, sieropositività, trapianto di organi e tessuti e
            monitoraggio della spesa sanitaria; – dati idonei a rivelare la vita
            sessuale o la sfera psichica, trattati da associazioni, enti ed
            organismi senza scopo di lucro, anche non riconosciuti, a carattere
            politico, filosofico, religioso o sindacale; – dati trattati con
            l’ausilio di strumenti elettronici volti a definire il profilo o la
            personalità dell’interessato o ad analizzare abitudini e scelte di
            consumo ovvero a monitorare l’utilizzo di servizi di comunicazione
            elettronica con esclusione dei trattamenti tecnicamente
            indispensabili per fornire i servizi medesimi agli utenti; – dati
            sensibili registrati in banche di dati a fini di selezione del
            personale per conto terzi nonché dati sensibili utilizzati per
            sondaggi di opinione, ricerche di mercato ed altre ricerche
            campionarie; – dati registrati in apposite banche dati gestite con
            strumenti elettronici e relative al rischio sulla solvibilità
            economica, alla situazione patrimoniale, al corretto adempimento di
            obbligazioni, a comportamenti illeciti o fraudolenti. VI – SICUREZZA
            DEI DATI FORNITI Il presente sito tratta i dati degli utenti in
            maniera lecita e corretta, adottando le opportune misure di
            sicurezza volte ad impedire accessi non autorizzati, divulgazione,
            modifica o distruzione non autorizzata dei dati. Il trattamento
            viene effettuato mediante strumenti informatici e/o telematici, con
            modalità organizzative e con logiche strettamente correlate alle
            finalità indicate. Oltre al titolare, in alcuni casi, potrebbero
            avere accesso ai dati categorie di incaricati coinvolti
            nell’organizzazione del sito (personale amministrativo, marketing,
            commerciale, legali, amministratori di sistema) ovvero soggetti
            esterni come (come fornitori di servizi tecnici terzi, corrieri
            postali, hosting provider, società informatiche, agenzie di
            comunicazione). VIII – MODIFICHE AL PRESENTE DOCUMENTO Il presente
            documento, pubblicato all’indirizzo: marcogomme costituisce
            la privacy policy di questo sito. Esso può essere soggetto a
            modifiche o aggiornamenti. Qualora si tratti di modifiche e
            aggiornamenti rilevanti questi saranno segnalati con apposite
            notifiche agli utenti. Le versioni precedenti del documento saranno
            consultabili, comunque, a questa pagina. Il documento è stato
            aggiornato in data 1 marzo 2023 per essere conforme alle disposizioni
            normative in materia ed in particolare al Regolamento UE 2016/679.
          </blockquote>
        </Modal.Body>
      </Modal>

      <div>
        {["Scopri di più"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              id="bottone"
              variant="contained"
              onClick={toggleDrawer(anchor, true)}
            >
              {anchor}
            </Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
    </React.Fragment>
  );
}
